
<div class="trigger-wrapper" (click)="triggerSelect(trigger, element)"
     cdkOverlayOrigin #trigger="cdkOverlayOrigin" #element>
  <div class="trigger" *ngIf="!showCustomTrigger"
       [ngClass]="{'disabled': isDisabled !== 'off' && isDisabled, 'is-open': selectListOpen$ | async}">
    <p class="trigger__label" [class.is-placeholder]="triggerTextIsPlaceholder">
      {{ triggerTextOutput }}
    </p>
    <mat-icon class="trigger__icon">
      {{ (selectListOpen$ | async) ? 'expand_less' : 'expand_more' }}
    </mat-icon>
  </div>

  <ng-content select="[trigger]"></ng-content>
</div>

<app-cdk-overlay [openTrigger$]="openCdkOverlay$">
  <div class="gl-select-window">
    <div class="gl-select-window__search" *ngIf="searchFieldMode === 'full'">
      <mat-checkbox color="primary" [(ngModel)]="checkboxAllChecked"
                    (change)="checkAll()"></mat-checkbox>
      <label class="gl-select-window__search-label" #searchContainer>
        <input type="text" [formControl]="searchControl" spellcheck="false"
               (focus)="searchContainer.classList.add('is-focus')"
               (blur)="searchContainer.classList.remove('is-focus')">
        <mat-icon>search</mat-icon>
      </label>
      <button class="gl-select-window__search-clear" (click)="searchControl.reset(); checkAll()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ul class="gl-select-list" *ngIf="isLoading">
      <li class="gl-select-list__item">
        <app-spinner [size]="'30px'"></app-spinner>
      </li>
    </ul>

    <div class="gl-select-window__container" *ngIf="!isLoading">
      <ul class="gl-select-list">
        <li class="gl-select-list__item single-select-item empty-result" *ngIf="!(resultList$ | async).length">
          Ничего не найдено
        </li>

        <ng-container *ngIf="!showCustomSelectList">
          <ng-container *ngFor="let item of resultList$ | async">
            <ng-container *ngIf="isMultipleSelect">
              <ng-container
                [ngTemplateOutlet]="multipleSearchItem"
                [ngTemplateOutletContext]="{ item }"
              ></ng-container>
            </ng-container>

            <ng-container *ngIf="!isMultipleSelect">
              <ng-container
                [ngTemplateOutlet]="singleSearchItem"
                [ngTemplateOutletContext]="{ item }"
              ></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-content select="[customSelectList]"></ng-content>
      </ul>
    </div>
  </div>
</app-cdk-overlay>

<ng-template #multipleSearchItem let-item="item">
  <li class="gl-select-list__item" *ngIf="item | typed:SelectItemType as selectItem">
    <mat-checkbox color="primary" [ngModel]="item.selected"
                  [matTooltip]="item.name | translateUsers"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="400"
                  [matTooltipDisabled]="!matTooltipLimitDisabled || selectItem.name.length <= matTooltipLimitDisabled"
                  (change)="multipleCheckItem($event, selectItem)">
      {{ selectItem.name | translateUsers }}
    </mat-checkbox>
  </li>
</ng-template>

<ng-template #singleSearchItem let-item="item">
  <!-- not tested -->
  <li class="gl-select-list__item single-select-item"
      (click)="singleSelectItem(item)"
      *ngIf="item | typed:SelectItemType as selectItem"
      [matTooltip]="selectItem.name | translateUsers"
      matTooltipPosition="right"
      [matTooltipShowDelay]="400"
      [matTooltipDisabled]="!matTooltipLimitDisabled || selectItem.name.length <= matTooltipLimitDisabled">
    {{ selectItem.name }}
  </li>
</ng-template>
